// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3GOYv","info":"PatientInfo_info__2fRWk"};